import { render, staticRenderFns } from "./BoRecipe.vue?vue&type=template&id=528ae552&"
import script from "./BoRecipe.vue?vue&type=script&lang=js&"
export * from "./BoRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports